import type { SoccerView } from '@minigame-race/contracts';
import type { MinigameProps } from '../../race/types.js';
import { SoccerBoard } from '../../turn/SoccerBoard.js';
import { TurnBoardFrame } from '../../turn/TurnBoardFrame.js';

/** Soccer as a race segment. See ConnectFourGame for the turn-adapter note. */
export function SoccerGame({ view, emit }: MinigameProps) {
  const v = view as (SoccerView & { yourSeat: 0 | 1; yourTurn: boolean; moveMsLeft: number; moveCapMs: number }) | null;
  if (!v || v.kind !== 'soccer') return null;
  return (
    <TurnBoardFrame>
      <SoccerBoard view={v} onMove={emit} />
    </TurnBoardFrame>
  );
}
